const UNSET_INCOTERMS = "none";

export function resolveDefaultIncoterms(
  incotermDefault: string | undefined,
  currentValue?: string | null,
): string | null {
  // Cleared by the user — do not re-apply a default (e.g. after accordion remount on Review).
  if (currentValue === null || currentValue === "") {
    return null;
  }

  const normalizedCurrent = currentValue?.toLowerCase();
  if (normalizedCurrent && normalizedCurrent !== UNSET_INCOTERMS) {
    return normalizedCurrent;
  }

  const normalizedDefault = incotermDefault?.toLowerCase();
  if (normalizedDefault) {
    return normalizedDefault;
  }

  return normalizedCurrent || UNSET_INCOTERMS;
}
